export const SOCIAL_NETWORKS = {
  vk: {
    name: 'Vk',
    url: 'http://vk.com/fundayshop',
  },
  telegram: {
    name: 'Telegram',
    url: 'https://t.me/fundaystores',
  },
  ok: {
    name: 'Ok',
    url: 'http://www.odnoklassniki.ru/fundayshop',
  },
};
